import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { COLOR } from 'vars/color'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const CastOptionIsNotAllowedSC = styled.div<{ smallPlayer?: boolean }>`
  width: 18rem;
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(${FIXED_INDENTS.INDENT_50});

  ${MEDIA.MIN_600} {
    gap: var(${FIXED_INDENTS.INDENT_60});
    width: ${({ smallPlayer }) => (smallPlayer ? '19rem' : '20rem')};
  }

  ${MEDIA.MIN_1240} {
    gap: var(${FIXED_INDENTS.INDENT_60});
    width: ${({ smallPlayer }) => (smallPlayer ? '19rem' : '26.5rem')};
  }

  ${ButtonSC} {
    width: fit-content;
    padding: ${({ smallPlayer }) =>
      smallPlayer
        ? `var(${FIXED_INDENTS.INDENT_30}) var(${FIXED_INDENTS.INDENT_60})`
        : `var(${FIXED_INDENTS.INDENT_30}) var(${FIXED_INDENTS.INDENT_180})`};

    ${MEDIA.MIN_1240} {
      padding: ${({ smallPlayer }) =>
        smallPlayer
          ? `var(${FIXED_INDENTS.INDENT_30}) var(${FIXED_INDENTS.INDENT_60})`
          : `var(${FIXED_INDENTS.INDENT_30}) var(${FIXED_INDENTS.INDENT_130})`};
    }
  }
`

export const OverlaySC = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(${COLOR.SURFACE_OPACITY_DARK_70});
`
